export default {
    title: "Katalógus",
    noAvailableItems: "Nincsenek megrendelhető termékek."
}